import React from 'react';

function PatientInfoForm({ fields, lookups, onPatientInfoSubmit, onPatientInfoChange }) { 
   const handleSubmit = (e) => {
      e.preventDefault();
      const patientInfo = new FormData(e.target);
      onPatientInfoSubmit(patientInfo);
   };
   return (
      fields && fields.length > 0 && (
         <form className='p-4 border rounded shadow-sm' onSubmit={handleSubmit}>
            <div className='row'>
               {fields.map((field, index) => {
                  if (field.type === 'hidden') return null;
                  let inputName = (field.id === 'firstName' || field.id === 'lastName') ? field.id : field.name;
                  switch (field.type) {
                     case 'lookup':
                        return (
                           <div key={index} className="form-group mt-3 col-10">
                              <label htmlFor={inputName} className="form-label fw-semibold">{field.label || field.name}</label>
                              { field.required && <small className="text-danger fw-bold mx-1">*</small>}
                              <select defaultValue={""} className="form-control p-2" name={inputName} required={field.required} onChange={onPatientInfoChange}>
                                 <option disabled value=""> -- Select an option -- </option>
                                 {lookups[field.lookup] && lookups[field.lookup].map((option, idx) => (
                                    <option key={idx} value={option.value}>{option.label}</option>
                                 ))}
                              </select>
                              
                           </div>
                        );
                     case 'dropdown':
                        return (
                           <div key={index} className="form-group mt-3 col-10">
                              <label htmlFor={inputName} className="form-label fw-semibold">{field.label || field.name}</label>
                              { field.required && <small className="text-danger fw-bold mx-1">*</small>}
                              <select defaultValue={""} className="form-control p-2" name={inputName} required={field.required} onChange={onPatientInfoChange}>
                                 <option disabled value=""> -- Select an option -- </option>
                                 {field.options.map((option, idx) => (
                                    <option key={idx} value={option.option}>{option.option}</option>
                                 ))}
                              </select>
                              
                           </div>
                        );
                     case 'checkbox':
                        return (
                           <div key={index} className="form-group mt-3 col-12">
                              
                              <label className="form-check-label fw-semibold" htmlFor={inputName}>{field.label || field.name}</label>
                              { field.required && <small className="text-danger fw-bold mx-1">*</small>}
                              <input type="checkbox" className="form-check-input mx-1" name={inputName} id={inputName} required={field.required} value="true" onChange={onPatientInfoChange}/>
                              
                           </div>
                        );
                     default:
                        return (
                           <div key={index} className="form-group mt-3 col-lg-6 col-sm-10">
                              <label htmlFor={inputName} className="form-label ">{field.label || field.name}</label>
                              { field.required && <small className="text-danger fw-bold mx-1">*</small>}
                              <input type={field.type} className="form-control form-control-alternative col-10" name={inputName} required={field.required} onChange={onPatientInfoChange}/>
                              
                           </div>
                        );
                  }
               })}
            </div>
            <button type="submit" className="btn btn-primary mt-2">Create Patient Link</button>

         </form>
      )
   )
}

export default PatientInfoForm;